class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.isHoverMenu = this.mainDetailsToggle.classList.contains('mega-menu--hover');

    console.log('HeaderMenu initialized:', {
      element: this.mainDetailsToggle,
      isHoverMenu: this.isHoverMenu,
      classList: Array.from(this.mainDetailsToggle.classList)
    });

    // For hover menus, use JavaScript to handle hover (desktop only)
    if (this.isHoverMenu) {
      console.log('Setting up hover menu with JavaScript');
      const summary = this.mainDetailsToggle.querySelector('summary');
      let closeTimeout;

      // Check if we're on desktop (990px and above)
      const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;

      // Prevent click from toggling on desktop only
      summary.addEventListener('click', (e) => {
        if (isDesktop()) {
          e.preventDefault();
          console.log('Click prevented on hover menu (desktop)');
        }
      });

      // Open on hover (desktop only)
      this.addEventListener('mouseenter', () => {
        if (!isDesktop()) return;
        console.log('Mouse entered - opening menu');
        // Clear any pending close timeout
        if (closeTimeout) {
          clearTimeout(closeTimeout);
          closeTimeout = null;
        }
        this.mainDetailsToggle.setAttribute('open', '');
      });

      // Close on mouse leave with a small delay (desktop only)
      this.addEventListener('mouseleave', () => {
        if (!isDesktop()) return;
        console.log('Mouse left - scheduling close');
        // Add a small delay before closing
        closeTimeout = setTimeout(() => {
          console.log('Closing menu');
          this.mainDetailsToggle.removeAttribute('open');
        }, 100);
      });
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
